import React from 'react'
import { FormikProps } from 'formik'
import { Checkbox as BsCheckbox } from 'bs-unified-ui'

interface CheckboxProps {
  field: {
    name: string
    value: any
  }
  meta: {
    touched?: boolean
    error?: string
  }
  form: FormikProps<any>
  disabled?: boolean
  [key: string]: any
}

const Checkbox: React.FC<CheckboxProps> = ({
  field,
  meta = {},
  form,
  disabled = false,
  ...props
}) => (
  <BsCheckbox
    checked={!!field.value}
    error={meta.touched && !!meta.error}
    disabled={disabled || !!form.values.__readOnly}
    {...field}
    {...props}
  />
)

export default Checkbox
